module.exports = __webpack_public_path__ + "static/media/hypokaustenheizung2.90bd1028.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/hypokaustenheizung2.JPG
// module id = 771
// module chunks = 0